import { ListCountries } from './__generated__/ListCountries'

import { gql } from 'apollo-boost'
import { useQuery } from '@apollo/react-hooks'

const QUERY = gql`
  query ListCountries {
    countries {
      id
      country
      timezones {
        id
        timezoneCity
      }
    }
  }
`

export const useListCountries = () => {
  return useQuery<ListCountries>(QUERY)
}
